// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/chevron-left.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'chevron-left',
  version: 'solid',
  paths: [
    {
      d: 'M14.136 6.264a.9.9 0 0 1 0 1.272L9.672 12l4.464 4.464a.9.9 0 1 1-1.272 1.272l-5.1-5.1a.9.9 0 0 1 0-1.272l5.1-5.1a.9.9 0 0 1 1.272 0',
      fillRule: 'evenodd',
    },
  ],
}
